import React, { useEffect, useState } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import LinksContainer from "../LinksContainer";
import styles from "./index.module.css";
import { useSelector } from "react-redux";

const SortableItem = SortableElement(({ value, isAnyMenuOpened, isMenuOpened, setIsMenuOpened, brandsIcons, closeMenu }) => (
    <LinksContainer
        item={value}
        isAnyMenuOpened={isAnyMenuOpened}
        isMenuOpened={isMenuOpened}
        setIsMenuOpened={setIsMenuOpened}
        brandsIcons={brandsIcons}
        closeMenu={closeMenu}
    />
));

const index = SortableContainer(({ items }) => {
    const [isMenuOpened, setIsMenuOpened] = useState(-1);
    const brandsIcons = useSelector((store) => store.root.dashboard.brandsIcons);

    useEffect(() => {
        const handleClickOutside = () => {
            setIsMenuOpened(-1);
        };
        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div className={styles.collectionsContainer}>
            {items.map((linksSection, index) => {
                return (
                    !linksSection.isDeleted && (
                        <SortableItem
                            key={`item-${index}`}
                            index={index}
                            value={linksSection}
                            isMenuOpened={isMenuOpened === index}
                            isAnyMenuOpened={isMenuOpened > -1}
                            setIsMenuOpened={() => {
                                setIsMenuOpened(index);
                            }}
                            brandsIcons={brandsIcons}
                            closeMenu={() => {
                                setIsMenuOpened(-1);
                            }}
                        />
                    )
                );
            })}
        </div>
    );
});

export default index;
